import { type OfferResponseDto } from '@wwt/entities/api/search-response'
import { Offer, OfferWithoutPrice } from '@wwt/entities/search-response'

import { OfferPrice } from '@/entities/offerPrice'

import { getHotelDynamic } from './getHotelDynamic.ts'
import { getHotelStatic } from './getHotelStatic.ts'
import { getRoomDynamic } from './getRoomDynamic.ts'
import { getRoomStatic } from './getRoomStatic.ts'

export const offerResponseDtoToOfferAdapter = (
	offerResponseDto: OfferResponseDto
): Offer => {
	const {
		metaData,
		offerDynamicData: {
			roomDynamicData: roomDynamicBase,
			hotelDynamicData: hotelDynamicBase
		},
		offerStaticData: {
			roomStaticData: roomStaticBase,
			hotelStaticData: hotelStaticBase
		}
	} = offerResponseDto

	const hotelStatic = getHotelStatic(hotelStaticBase)
	const hotelDynamic = getHotelDynamic(hotelDynamicBase)
	const roomStatic = getRoomStatic(roomStaticBase)
	const roomDynamic = getRoomDynamic(roomDynamicBase)

	const offerWithoutPrice: OfferWithoutPrice = {
		hotelStatic,
		hotelDynamic,
		roomStatic,
		roomDynamic,
		IDs: metaData
	}

	const price: OfferPrice = Object.create(OfferPrice).init(offerWithoutPrice)

	return {
		...offerWithoutPrice,
		price: price
	}
}
